import axios from 'axios';
import fixOpts from '@/framework/utils-project/fixOpts';
import { baseUrlFull } from './baseUrl';
import { getHttpErrorMessage } from './httpErrorPolicy.mjs';
import { isLegacyApiErrorResponse } from './responsePolicy.mjs';
import {
  authorizationStorage,
  userInfoStorage,
  xTokenStorage,
} from '@/storages/sessionStorage';
import { menuRightsStorage } from '@/storages/localStorage';
import { clearLegacyBackofficeSession } from '@/features/auth/wecomSessionBootstrap.mjs';
import { createSessionExpiryHandler } from '@/features/auth/sessionExpiryPolicy.mjs';

function requestStart(url) {
  let _isMissLoading = url.indexOf('isMissLoading=true') != -1;
  if (!JSON.parse(_isMissLoading)) {
    if (window.yhcLoadingCount == 0) {
      window.yhcLoadingShow();
    }
    window.yhcLoadingCount++;
  }
}

function requestEnd(url) {
  let _isMissLoading = url.indexOf('isMissLoading=true') != -1;
  if (!JSON.parse(_isMissLoading)) {
    window.yhcLoadingCount--;
    if (window.yhcLoadingCount == 0) {
      window.yhcLoadingHide();
    }
  }
}

function tip(s, t = 'error') {
  window.yhcToastShow({
    message: s,
    type: t,
  });
}

// 所有后台接口共享同一个处理器，确保并发 401 只触发一次退出流程。
const handleSessionExpiry = createSessionExpiryHandler({
  clearSession: () => {
    clearLegacyBackofficeSession({
      userInfoStorage,
      authorizationStorage,
      menuRightsStorage,
      xTokenStorage,
    });
  },
  notify: (message) => tip(message),
  isLoginRoute: () => window.location.hash.replace(/^#/, '').split('?')[0] === '/login',
  // 后台使用 hash 路由；保留当前部署路径，只切换前端页面。
  redirectToLogin: () => {
    window.location.hash = '#/login';
  },
});

const http = axios.create({
  baseURL: baseUrlFull,
  timeout: 120000000,
  // Password and Enterprise WeChat login share the protected server session cookie.
  withCredentials: true,
});

// request拦截器
http.interceptors.request.use(
  (config) => {
    // let userInfoStorageVal = userInfoStorage.get() || {}
    // config.headers['User-Id'] = userInfoStorageVal.id || ''
    // config.headers['Authorization'] = xTokenStorage.get() || ''

    let { url } = config;

    let fixConfig = fixOpts(config);
    let isBlobReq = url.indexOf('blob') != -1;

    requestStart(url);

    // 返回axios的配置
    if (isBlobReq) {
      return config;
    } else {
      return fixConfig;
    }
  },
  (error) => {
    Promise.reject(error);
  }
);

// respone拦截器
http.interceptors.response.use(
  (response) => {
    let { data, config } = response;

    let { url } = config;

    requestEnd(url);

    // Only explicit legacy error envelopes belong to the global error handler.
    // Semantic command responses use `succeeded` and must reach their page intact.
    if (isLegacyApiErrorResponse(data)) {
      console.log('response reject');
      console.log(response);
      switch (data.errorCode * 1) {
        // case 401:
        //   break
        default:
          tip(data.message);
          break;
      }
      return Promise.reject(data);
    } else {
      return data;
    }
  },
  (error) => {
    console.warn('检查是否有参数为空值');

    window.yhcLoadingCount--;
    if (window.yhcLoadingCount == 0) {
      window.yhcLoadingHide();
    }

    // 401 由会话策略统一清理和跳转；其他错误沿用现有具体原因提示。
    if (!handleSessionExpiry(error)) {
      tip(getHttpErrorMessage(error));
    }

    return Promise.reject(error);
  }
);

export default http;
